import { useEffect, useState } from "react"
import { call_func, hash } from "@/shared"

let cache: any = {}

//export type UseDataProps = { mode: string, id: any }
export type UserQueryProps = {
  args: any,
  allowEmptyVariables?: boolean,
  runQuery?: boolean,
  refreshCounter?: number,
  useCache?: boolean,
  cacheTime?: number
}

export async function doQuery(query: Function, args: any, useCache: boolean = false, cacheTime: number = 10) {
  if (useCache) {
    const timestamp = Date.now()
    const cacheKey: string = hash(args)
    if (cache[cacheKey] && cache[cacheKey].timestamp > timestamp) return cache[cacheKey].value

    if (args.params) return await call_func(query, args.params)
    cache[cacheKey] = { value: await query(args), timestamp: timestamp + (cacheTime * 1000) }
    return cache[cacheKey]
  } else {
    if (args.params) return await call_func(query, args.params)
    return await query(args)
  }
}

export default function useQuery(query: Function, {
  args,
  allowEmptyVariables = true,
  runQuery = true,
  refreshCounter = 0,
  useCache = false,
  cacheTime = 10 }: UserQueryProps) {

  const [data, setData] = useState<any>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<any>(false)

  useEffect(() => {
    const _waitForData = async () => {
      try {
        if (runQuery) {
          if (allowEmptyVariables || args) {
            const res = await doQuery(query, args, useCache, cacheTime) as any
            setData(res?.data || [])
          }
          setLoading(false)
        }
      }
      catch (err: any) {
        if (err.response) {
          console.log('data:', err.response.data)
          console.log('status:', err.response.status)
          console.log('headers:', err.response.headers)
        }
        else {
          console.log('Error:', err.message)
        }
        setError(err)
      }
      return () => {
        setLoading(false)
      }
    }
    _waitForData()
    // On the counter itself: the effect hung on a ref that was only set to the
    // new counter after the dependencies had been read, so every reload came
    // one render late — a paged list showed the next page number over the
    // previous page's rows, and a second click went to an empty page.
  }, [refreshCounter])

  return { data, loading, error }
}